import { Injectable } from '@angular/core';
import { CheckoutActions } from '@checkout/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomUserActions } from '@user/data-access';
import { Observable, filter, map } from 'rxjs';

@Injectable()
export class ApplyingBonusEffects {
  resetApplyingBonusWhenChangeLegalEntity$: Observable<CheckoutActions.SetApplyingBonus> = createEffect(() =>
    this.actions$.pipe(
      ofType<CustomUserActions.SetLegalEntityStatus>(CustomUserActions.SET_LEGAL_ENTITY_STATUS),
      filter((action) => Boolean(action.payload)),
      map(() => new CheckoutActions.SetApplyingBonus(0)),
    ),
  );

  constructor(private actions$: Actions) {}
}
